/**
 * Scroll users screen to a ref
 * @param {object} ref - a ref to some element to scroll to
 * @example scrollToRef(myReactRef)
 * @description If there is no ref or ref.current, the screen is
 * not scrolled. If there is a ref and ref.current, the user will
 * be scrolled by setting root.scrollTop. The ref will at the top
 * of the screen with regard to the header height plus a 10px padding.
 */
const scrollToRef = ref => {
  if (ref && ref.current) {
    const root = document.getElementById("root");
    const headerNode = document.querySelector(".header");
    const scrollTopPadding = 10;
    const scrollOffset =
      (headerNode && headerNode.clientHeight) +
      scrollTopPadding -
      root.scrollTop;
    const { top: targetOffset } = ref.current.getBoundingClientRect();
    root.scrollTop = targetOffset - scrollOffset;
  }
};

export { scrollToRef };
